<template>
  <div class="flex gap-2 items-center">
    <span class="font-bold text-xs text-neutral-400">Groepeer:</span>
    <UButtonGroup>
      <LocationsListHeaderGroupByToggleButton
        label="Onderzoek"
        group-type="article"
      />
      <LocationsListHeaderGroupByToggleButton
        label="Dier"
        group-type="animal"
      />
    </UButtonGroup>
  </div>
</template>
